import React from 'react';

import { IOembedRich, IOembedVideo } from 'types/prismicVideo';

import { Container } from 'components/container/Container';
import { Row } from 'components/row/Row';

import s from './Embed.scss';
import Helmet from 'react-helmet';
import { Instagram } from './Instagram';

interface IProps {
  oembed: IOembedVideo | IOembedRich;
  container?: boolean;
  isColumnLayout?: boolean;
}

export const Embed = ({ oembed, container = true }: IProps) => {
  const Wrapper = container ? Container : 'div';
  const {
    provider_name,
    title,
    thumbnail_width,
    thumbnail_height,
    thumbnail_url,
    embed_url,
    author_name,
  } = oembed;
  const embedName = provider_name ? provider_name.toLocaleLowerCase() : '';

  // Check for specific providers we need to inject scripts for
  let scripts = null;

  // how to render embed based on provider
  let render = (
    <div className={s('embed', { offset: container, wide: oembed.width === '100%' })}>
      <div className={s.embed__content} dangerouslySetInnerHTML={{ __html: oembed.html }} />
    </div>
  );

  switch (embedName) {
    case 'instagram':
      render = (
        <Instagram
          offset={container}
          link={embed_url!}
          text={title!}
          image={thumbnail_url}
          width={thumbnail_width!}
          height={thumbnail_height!}
          profile={author_name!}
        />
      );
      break;
    case 'facebook':
      scripts = (
        <script
          async
          defer
          crossOrigin="anonymous"
          src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v6.0"
        ></script>
      );
      break;
    case 'twitter':
      scripts = (
        <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>
      );
      break;
    default:
      break;
  }

  return (
    <>
      {scripts && <Helmet>{scripts}</Helmet>}
      <Wrapper>
        <Row>{render}</Row>
      </Wrapper>
    </>
  );
};
